import React from 'react';
import { useTranslation } from 'react-i18next';

import { Link } from 'react-router-dom';

interface IStandartCard {
  sellerId: string,
  pathname: string,
  Icon: React.FC<{fill: string}>,
  title: string,
  colors: {from: string, to: string},
  description: string,
  buttonText?: string,
  separator?: string
}

const StandartCard: React.FC<IStandartCard> = ({ 
  sellerId,
  pathname, 
  Icon,
  title,
  colors,
  description,
  buttonText = "add",
  separator = "+"
}) => {
  
  const { t } = useTranslation();

  return (
    <Link
      className="
      cursor-pointer bg-white shadow-lg rounded-sm shadow-sm transition-all
      "
      to={`${pathname.replace(":id", sellerId)}`}>
      <div className="flex flex-col p-5 border border-gray-200 hover:border-gray-300 h-full">
        <div className="flex-grow">
          <header className="flex items-center mb-4">
            <div 
              className={`w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0 mr-3`}
            >
              <Icon fill='#1F55A1' />
            </div>
            <h3 className="text-base text-gray-800 text-left font-semibold">
              {t(title, { ns: 'messages' })}
            </h3>
          </header>
          <div className="text-sm text-left w-10/12 text-black">
            {t(description)}.
          </div>
        </div>
        <footer className="mt-4">
          <div className="flex flex-wrap  justify-between items-center">
            <button className="btn-sm border-gray-200 hover:border-gray-300 shadow-sm flex items-center">
              <span className="text-[#1f55a1]">
                {t(buttonText, { ns: 'messages' })}
              </span>
            </button>
          </div>
        </footer>
      </div>
    </Link>
  );
}

export default StandartCard;
